import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const ColumnActionsMenuAutomationItemsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "async-moon-experiment-automation-discovery-on-board-columns-column-actions-menu-automation-items" */ './main'
		).then((module) => module.ColumnActionsMenuAutomationItemsContainer),
	),
	getPreloadProps: () => ({}),
});
